import { useGlobalState } from "GlobalStateContext";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import spinnerWhiteSvg from "../assets/svg/spinner-white.svg";

interface Props {
  checkout?: boolean;
  loading?: boolean;
  reassignServiceFlag?: boolean;
  setChangeServiceType?: React.Dispatch<React.SetStateAction<boolean>>;
  setShowReassignQuotePopup?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ToggleDelivery: React.FC<Props> = ({
  checkout,
  loading,
  reassignServiceFlag,
  setChangeServiceType,
  setShowReassignQuotePopup,
}) => {
  const { t } = useTranslation();
  const { pickup, setPickup, isToggleable } = useGlobalState();
  const [showPopup, setShowPopup] = useState(false);
  const { pathname } = useLocation();
  const onRestListPage = pathname.slice(0, 19) === "/dashboard/restlist";

  const handleSelect = (mode: "Delivery" | "Pickup") => {
    if (isToggleable || onRestListPage) {
      const isPickup = mode === "Pickup";
      if (pickup !== isPickup) {
        setPickup(isPickup);
      }
    } else if (
      (pickup && mode !== "Pickup") ||
      (!pickup && mode !== "Delivery")
    )
      handleNotToggleable();
  };

  const handleSelectCheckout = (mode: "Delivery" | "Pickup") => {
    setChangeServiceType && setChangeServiceType(true);
    if (
      isToggleable &&
      ((pickup && mode !== "Pickup") || (!pickup && mode !== "Delivery"))
    ) {
      setShowReassignQuotePopup && setShowReassignQuotePopup(true);
    } else if (
      (pickup && mode !== "Pickup") ||
      (!pickup && mode !== "Delivery")
    )
      handleNotToggleable();
  };

  const handleNotToggleable = () => {
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 2000);
  };

  useEffect(
    () => {
      if (checkout) {
        if (reassignServiceFlag) {
          setPickup(!pickup);
        }
      }
    },
    // eslint-disable-next-line
    [reassignServiceFlag]
  );

  return (
    <div className="flex flex-col items-center justify-center relative">
      <div className="flex bg-[#38435b] bg-opacity-25 rounded-full p-1">
        {loading ? (
          <div className="px-20 py-1 md:py-1.5">
            <img
              className="h-5 animate-spin"
              src={spinnerWhiteSvg}
              alt="loading spinner"
            />
          </div>
        ) : (
          <>
            <button
              className={`px-4 py-1 rounded-full transition text-slate-100 text-sm sm:text-base ${
                !pickup
                  ? "bg-slate-600 shadow-md"
                  : "bg-transparent hover:bg-slate-700 transition duration-300 ease-in-out"
              }`}
              onClick={() =>
                checkout
                  ? handleSelectCheckout("Delivery")
                  : handleSelect("Delivery")
              }
            >
              {t("checkOut.delivery")}
            </button>
            <button
              className={`px-4 py-1 rounded-full transition text-slate-100 text-sm sm:text-base ${
                pickup
                  ? "bg-slate-600 shadow-md"
                  : "bg-transparent hover:bg-slate-700 transition duration-300 ease-in-out"
              }`}
              onClick={() =>
                checkout
                  ? handleSelectCheckout("Pickup")
                  : handleSelect("Pickup")
              }
            >
              {t("checkOut.pickup")}
            </button>
          </>
        )}
      </div>
      {showPopup && (
        <div className="absolute top-12 bg-gray-900 text-white text-sm px-4 py-2 rounded-md shadow-md z-50">
          {pickup ? (
            <>
              {t("checkOut.delivery")} {t("mealCreator.notAvailable")}
            </>
          ) : (
            <>
              {t("checkOut.pickup")} {t("mealCreator.notAvailable")}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default ToggleDelivery;
